'use strict';

var index = require('../../../../_virtual/index5.cjs');
var dark$1 = require('./node_modules/aviary-tokens/dist/tokens/native/themes/dark.cjs');
var light$1 = require('./node_modules/aviary-tokens/dist/tokens/native/themes/light.cjs');
var dark = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/dark.cjs');
var emerson = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/emerson.cjs');
var light = require('./node_modules/aviary-tokens/dist/tokens/ts/themes/light.cjs');
var lightDesktop1024 = require('./packages/aviary-tokens/dist/emerson/web/light-desktop1024.cjs');
var lightDesktop1280 = require('./packages/aviary-tokens/dist/emerson/web/light-desktop1280.cjs');
var lightMobile375 = require('./packages/aviary-tokens/dist/emerson/web/light-mobile375.cjs');
var lightTablet834 = require('./packages/aviary-tokens/dist/emerson/web/light-tablet834.cjs');
var darkMobile375 = require('./packages/aviary-tokens/dist/fullscript/native/dark-mobile375.cjs');
var lightMobile375$1 = require('./packages/aviary-tokens/dist/fullscript/native/light-mobile375.cjs');
var darkDesktop1024 = require('./packages/aviary-tokens/dist/fullscript/web/dark-desktop1024.cjs');
var darkDesktop1280 = require('./packages/aviary-tokens/dist/fullscript/web/dark-desktop1280.cjs');
var darkMobile375$1 = require('./packages/aviary-tokens/dist/fullscript/web/dark-mobile375.cjs');
var darkTablet834 = require('./packages/aviary-tokens/dist/fullscript/web/dark-tablet834.cjs');
var lightDesktop1024$1 = require('./packages/aviary-tokens/dist/fullscript/web/light-desktop1024.cjs');
var lightDesktop1280$1 = require('./packages/aviary-tokens/dist/fullscript/web/light-desktop1280.cjs');
var lightMobile375$2 = require('./packages/aviary-tokens/dist/fullscript/web/light-mobile375.cjs');
var lightTablet834$1 = require('./packages/aviary-tokens/dist/fullscript/web/light-tablet834.cjs');

var hasRequiredCjs;

function requireCjs () {
	if (hasRequiredCjs) return index.__exports;
	hasRequiredCjs = 1;

	var dark$1$1 = dark$1.__require();
	var light$1$1 = light$1.__require();
	var dark$2 = dark.__require();
	var emerson$1 = emerson.__require();
	var light$2 = light.__require();
	var lightDesktop1024$1$1 = lightDesktop1024.__require();
	var lightDesktop1280$1$1 = lightDesktop1280.__require();
	var lightMobile375$2$1 = lightMobile375.__require();
	var lightTablet834$1$1 = lightTablet834.__require();
	var darkMobile375$1$1 = darkMobile375.__require();
	var lightMobile375$1$1 = lightMobile375$1.__require();
	var darkDesktop1024$1 = darkDesktop1024.__require();
	var darkDesktop1280$1 = darkDesktop1280.__require();
	var darkMobile375$2 = darkMobile375$1.__require();
	var darkTablet834$1 = darkTablet834.__require();
	var lightDesktop1024$2 = lightDesktop1024$1.__require();
	var lightDesktop1280$2 = lightDesktop1280$1.__require();
	var lightMobile375$3 = lightMobile375$2.__require();
	var lightTablet834$2 = lightTablet834$1.__require();

	const fullscriptWebLight = {
	    mobile375: {
	        ...light$2,
	        ds5: lightMobile375$3
	    },
	    tablet834: {
	        ...light$2,
	        ds5: lightTablet834$2
	    },
	    desktop1024: {
	        ...light$2,
	        ds5: lightDesktop1024$2
	    },
	    desktop1280: {
	        ...light$2,
	        ds5: lightDesktop1280$2
	    }
	};
	const fullscriptWebDark = {
	    mobile375: {
	        ...dark$2,
	        ds5: darkMobile375$2
	    },
	    tablet834: {
	        ...dark$2,
	        ds5: darkTablet834$1
	    },
	    desktop1024: {
	        ...dark$2,
	        ds5: darkDesktop1024$1
	    },
	    desktop1280: {
	        ...dark$2,
	        ds5: darkDesktop1280$1
	    }
	};
	const fullscriptNativeLight = {
	    ...light$1$1,
	    ds5: lightMobile375$1$1
	};
	const fullscriptNativeDark = {
	    ...dark$1$1,
	    ds5: darkMobile375$1$1
	};
	const emersonWeb = {
	    mobile375: {
	        ...emerson$1,
	        ds5: lightMobile375$2$1
	    },
	    tablet834: {
	        ...emerson$1,
	        ds5: lightTablet834$1$1
	    },
	    desktop1024: {
	        ...emerson$1,
	        ds5: lightDesktop1024$1$1
	    },
	    desktop1280: {
	        ...emerson$1,
	        ds5: lightDesktop1280$1$1
	    }
	};

	index.__exports.emersonWeb = emersonWeb;
	index.__exports.fullscriptNativeDark = fullscriptNativeDark;
	index.__exports.fullscriptNativeLight = fullscriptNativeLight;
	index.__exports.fullscriptWebDark = fullscriptWebDark;
	index.__exports.fullscriptWebLight = fullscriptWebLight;
	
	return index.__exports;
}

exports.__require = requireCjs;
//# sourceMappingURL=index.cjs.map
